/**
 * מחיר הצעה ציבורית (packages/profile/:id) — deterministic, persisted בלבד.
 * אין fallbacks ל-selectedResult / fullDeal / חישוב מחדש.
 */

function round2(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return NaN;
  return Math.round(x * 100) / 100;
}

function parsePositiveMoney(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return round2(n);
}

/** שדה המכירה השמור היחיד שנחשב תקף לתצוגת לקוח */
export const PERSISTED_PUBLIC_OFFER_PRICE_FIELD = "display_total_ils";

/**
 * @param {object|null|undefined} order — שורת הזמנה / הצעה מ-getLdsOrder
 * @returns {{ ils: number|null, fieldName: string|null, source: string }}
 */
export function resolvePersistedPublicOfferPackageIls(order) {
  if (!order || typeof order !== "object") {
    return { ils: null, fieldName: null, source: "none" };
  }
  const op = order.ourprice ?? order.ourPrice;

  // LDS success/profile total SSOT:
  // 1) order.sumpaid
  // 2) ourprice.priceWithCreditCardFee
  // 3) ourprice.priceWithHandleFee
  // 4) existing persisted fallbacks only
  const sumPaid = parsePositiveMoney(order.sumpaid);
  if (sumPaid != null) {
    return {
      ils: sumPaid,
      fieldName: "sumpaid",
      source: "persisted_order_ssot",
    };
  }

  if (op && typeof op === "object") {
    const withCc = parsePositiveMoney(op.priceWithCreditCardFee);
    if (withCc != null) {
      return {
        ils: withCc,
        fieldName: "priceWithCreditCardFee",
        source: "persisted_ourprice_ssot",
      };
    }
    const withHandle = parsePositiveMoney(op.priceWithHandleFee);
    if (withHandle != null) {
      return {
        ils: withHandle,
        fieldName: "priceWithHandleFee",
        source: "persisted_ourprice_ssot",
      };
    }
  }

  // Existing fallback chain (kept as a last resort only)
  const displayTotal = parsePositiveMoney(order.display_total_ils);
  if (displayTotal != null) {
    return {
      ils: displayTotal,
      fieldName: "display_total_ils",
      source: "persisted_order_fallback",
    };
  }

  if (!op || typeof op !== "object") {
    return { ils: null, fieldName: null, source: "none" };
  }
  const isPublicOrder =
    order?.is_public_site_order === true ||
    String(order?.order_source || "").trim().toLowerCase() === "public_site" ||
    (order?.public_site_id != null && String(order.public_site_id).trim() !== "") ||
    op.public_base_price_to_agent_ils != null ||
    op.public_markup_ils != null ||
    op.public_baggage_total_ils != null ||
    op.public_final_customer_price_ils != null;
  const publicFinal = parsePositiveMoney(op.public_final_customer_price_ils);
  if (publicFinal != null) {
    return {
      ils: publicFinal,
      fieldName: "public_final_customer_price_ils",
      source: "persisted_ourprice_public_fallback",
    };
  }
  if (isPublicOrder) {
    return { ils: null, fieldName: null, source: "public_missing_ssot" };
  }
  const snakeCc = parsePositiveMoney(op.price_with_credit_card_fee);
  if (snakeCc != null) {
    return {
      ils: snakeCc,
      fieldName: "price_with_credit_card_fee",
      source: "persisted_ourprice_snake_fallback",
    };
  }
  return { ils: null, fieldName: null, source: "none" };
}

/**
 * לוג זמני לבדיקות יציבות מחיר (רק development).
 */
export function logPublicOfferPriceAudit(payload) {
  if (process.env.NODE_ENV !== "development") return;
  console.log("[PUBLIC_OFFER_PRICE_AUDIT]", payload);
}
